import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { AccountSettings } from 'types/api/Account';

/* Account Settings endpoint for client admins */

export function getCaAccountSettings(id: number) {
  return axios.get<AccountSettings>(`/api/v2/ca/accounts/${id}/settings`);
}

export function useGetCaAccountSettings(accountId: number) {
  return useQuery({
    queryKey: ['ca', 'accounts', accountId, 'settings'],
    queryFn: () =>
      getCaAccountSettings(accountId).then(response => response.data)
  });
}
